"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const keysToCamelCase = (data) => lodash_1.mapKeys(data, (_v, key) => lodash_1.camelCase(key));
exports.default = keysToCamelCase;
//# sourceMappingURL=keys-to-camel-case.js.map